<template>
  <div class="common-modal">
    <div class="modal-backdrop"></div>
    <div class="modal">
      <div class="modal-inner">
        <div class="custom-modal-header">
          <div class="close-btn">
            <div class="btn-close" @click="$emit('close')"></div>
          </div>
          <p class="header">Schema importieren</p>
        </div>
        <div
          class="import-block"
          :class="{ 'dragged-over': dragHover }"
          @click="onImportClick"
          @dragover.prevent="onDragOver"
          @dragleave.prevent="onDragLeave"
          @drop.prevent="onDrop"
        >
          <input
            ref="importFileInputRef"
            style="display: none"
            type="file"
            accept="application/json"
            @change="onFileChange"
          />

          <img src="@/assets/img/file-icon.svg" class="file-upload-icon" />
          <p>Datei hierher ziehen oder klicken, um auszuwählen.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { showToaster } from '@/utils/helpers';

export default {
  name: 'JsonImportFormModal',
  data() {
    return {
      dragHover: false,
    };
  },
  methods: {
    onImportClick() {
      const importFileInputRef = this.$refs.importFileInputRef;
      if (importFileInputRef) {
        importFileInputRef.click();
      }
    },
    onDragOver() {
      this.dragHover = true;
    },
    onDragLeave() {
      this.dragHover = false;
    },
    onDrop(event) {
      this.dragHover = false;
      const droppedFiles = Array.from(event.dataTransfer.files);
      if (droppedFiles.length > 0) {
        this.onFileChange(droppedFiles[0]);
      }
    },
    onFileChange(file = []) {
      const importFileInputRef = this.$refs.importFileInputRef;
      if (importFileInputRef) {
        try {
          const finalFile =
            file?.length > 0 ? file[0] : importFileInputRef.files[0];

          if (!finalFile) {
            console.error('No file selected.');
            return;
          }

          const reader = new FileReader();
          const vueInstance = this;
          reader.onload = function () {
            try {
              const importedProcess = JSON.parse(reader.result);
              vueInstance.$emit('onFileImport', importedProcess);
            } catch (jsonError) {
              console.error('Error parsing JSON:', jsonError);
              showToaster(
                vueInstance,
                `Fehler beim Parsen der JSON-Datei: ${jsonError}`,
                'Fehlerhaft !',
                'danger'
              );
            }
          };

          reader.onerror = function (e) {
            console.error('Error reading file:', e);
            showToaster(
              vueInstance,
              `Fehler beim Lesen der Datei: ${e}`,
              'Fehlerhaft !',
              'danger'
            );
          };

          reader.readAsText(finalFile);
        } catch (error) {
          console.error('Unexpected error:', error);
          showToaster(
            this,
            `Unexpected error:: ${error}`,
            'Fehlerhaft !',
            'danger'
          );
        }
      }
    },
  },
};
</script>

<style scoped>
.common-modal .modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1055;
}

.common-modal .modal {
  padding: 0;
  width: 100%;
  height: 100%;
  background: transparent;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  border-radius: 10px;
  display: block;
}

.common-modal .modal .modal-inner {
  width: fit-content;
  height: fit-content;
  background: #fff;
  padding: 30px 40px 20px 40px;
  border-radius: 10px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  right: 0;
  margin: 0 auto;
  max-width: 520px;
}

.common-modal .custom-modal-header {
  box-sizing: border-box;
  display: block;
  position: relative;
  width: 100%;
  margin-bottom: 15px;
}

.common-modal .modal .btn-close:focus {
  outline: none;
  box-shadow: none;
}

.common-modal .modal .btn-close {
  position: absolute;
  right: -25px;
  top: -14px;
  padding: 0;
}

.common-modal .header {
  font-size: 18px;
  width: 100%;
  font-weight: 400;
  font-family: 'AktivGroteskMedium';
  margin-bottom: 0;
  color: #000;
}

.common-modal .import-block {
  min-height: 150px;
  max-height: 150px;
  width: 420px;
  border: 2px dashed grey;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 16px;
  gap: 16px;
  cursor: pointer;
}

.common-modal .import-block.dragged-over {
  background: #f1f1f1;
}

.common-modal .import-block p {
  font-size: 14px;
  width: 100%;
  font-weight: 400;
  font-family: 'AktivGroteskMedium';
  text-align: center;
  color: #000;
  margin: 0;
}

.common-modal .import-block .file-upload-icon {
  width: 30px;
}
</style>
